import React from "react";
import { Box, Tab } from "@mui/material";
import { useTranslation } from "next-i18next";
import { IWikifolioKeyFigureGroupSection } from "src/api/server/wf-detail.types";
import { WfHeading } from "src/components-mui/base/wf-heading/wf-heading";
import { PopoverButtonIconInfo } from "src/components-mui/base/wf-popover/popover-button-icon-info";
import { WfPopover } from "src/components-mui/base/wf-popover/wf-popover";
import { TabPanel } from "src/components-mui/tabs/tab-panel";
import { TabsContext } from "src/components-mui/tabs/tabs-context";
import { TabsList } from "src/components-mui/tabs/tabs-list";
import { KeyFigureGroup } from "./key-figure-group";

interface IBetaProps {
    betaSection: IWikifolioKeyFigureGroupSection;
}

export const Beta = ({ betaSection }: IBetaProps) => {
    const { t } = useTranslation("wf-detail");

    return (
        <React.StrictMode>
            <Box display="flex" alignItems="center" mb={2} gap={1}>
                <WfHeading component="h3" fontSize="md">
                    {t("headlines.beta")}
                </WfHeading>
                {betaSection.tooltip && (
                    <WfPopover
                        PopoverTrigger={<PopoverButtonIconInfo ariaLabel={t("headlines.beta")} />}
                        link={betaSection.tooltip.link}
                        content={betaSection.tooltip.content}
                    />
                )}
            </Box>

            <TabsContext initialValue={0}>
                <TabsList customVariant="full">
                    {betaSection.groups.map(keyFigureGroup => (
                        <Tab key={keyFigureGroup.label} label={keyFigureGroup.label}></Tab>
                    ))}
                </TabsList>
                <Box mt={2}>
                    {betaSection.groups.map((keyFigureGroup, index) => (
                        <TabPanel key={keyFigureGroup.label} value={index}>
                            <KeyFigureGroup keyFigureGroup={keyFigureGroup} />
                        </TabPanel>
                    ))}
                </Box>
            </TabsContext>
        </React.StrictMode>
    );
};
